export default __webpack_public_path__ + "static/media/certification-success.f9b58dd9.png";